<template>
<div>
    <business-partner-type-list></business-partner-type-list>
</div>
</template>
  
<script>
export default {}
</script>
